import { emailProviders } from './constants';

const NX_ENV = process.env['NX_ENV'];

const getFilterEmailAddress = () => {
  switch (NX_ENV) {
    case 'production':
      return 'subscription%40kaltura.com';
    default:
      return 'subscription%40nvd1.ovp.kaltura.com';
  }
};

export const getSniperLink = (provider: string, email: string): string => {
  const filterEmail = getFilterEmailAddress();
  switch (provider) {
    case emailProviders.GMAIL:
      return `https://mail.google.com/mail/u/${email}/#search/from%3A${filterEmail}+in%3Aanywhere+newer_than%3A1h`;
    case emailProviders.YAHOO:
      return `https://mail.yahoo.com/d/search/keyword=from%253A${filterEmail}`;
    case emailProviders.OUTLOOK:
      return `https://outlook.live.com/mail/?login_hint=${encodeURIComponent(email)}`;
    case emailProviders.ICLOUD:
      return `https://www.icloud.com/mail/`;
    default:
      return '';
  }
};
